export class ListParams {
  constructor(filters, options, search) {
    this.filters = filters ? JSON.parse(JSON.stringify(filters)) : null
    this.options = options ? JSON.parse(JSON.stringify(options)) : null
    this.search = search ? JSON.parse(JSON.stringify(search)) : null
  }
}
